import React, {useEffect, useState } from 'react';
import {MDBCol, MDBIcon, MDBRow} from "mdbreact";
import {Button, Container} from "@nextui-org/react";
import {Layout, Table} from "antd";
import { Input } from "@nextui-org/react";
import {useCollection} from "react-firebase-hooks/firestore";
import {collection, getFirestore, query, where} from "firebase/firestore";
import {ColumnsType} from "antd/lib/table";
import moment from 'moment';
import Firebase from "../../Firebase/Firebase";
import Headerbar from '../../navBars/Headerbar';
import Sidebar from '../../navBars/Sidebar';
import {generatePath, useNavigate} from "react-router-dom";
import {Tag} from "primereact/tag";


interface DataType {
    key: number;
    name: string;
    phone: string;
    email: string;
    userStatus: JSX.Element;
    createdAt: string;
    action: JSX.Element;
}
const { Content } = Layout;
const db = getFirestore(Firebase);
const Buyers = () => {

    const columns: ColumnsType<DataType> = [
        { title: '#', dataIndex: 'key', key: 'key', width: 50 },
        { title: 'Name', dataIndex: 'name', key: 'name', sorter: (a: DataType, b: DataType) => a.name.localeCompare(b.name) },
        { title: 'Phone', dataIndex: 'phone', key: 'phone' },
        { title: 'Email', dataIndex: 'email', key: 'email' },
        { title: 'Status', dataIndex: 'userStatus', key: 'userStatus' },
        { title: 'Joined', dataIndex: 'createdAt', key: 'createdAt', sorter: (a: DataType, b: DataType) => a.createdAt.localeCompare(b.createdAt) },
        { title: 'Action', key: 'action', dataIndex: 'action' },
    ];

    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);
    const [allRows, setAllRows] = useState<DataType[]>([]);
    const [dataArray, setDataArray] = useState<DataType[]>([]);
    const [searchText, setSearchText] = useState('');

    const [userSnapshot, loading] = useCollection(
        query(collection(db, 'users'), where('type', '==', 'buyer')),
        { snapshotListenOptions: { includeMetadataChanges: true } }
    );

    useEffect(() => {
        if (!userSnapshot) return;
        const rows: DataType[] = [];
        userSnapshot.docs.forEach((docSnap: any, index: number) => {
            const item = docSnap.data();
            const status: string = item.userStatus ?? '';
            const sev = status.toLowerCase() === 'active' ? 'success' : 'warning';
            const m = item.createdAt?.toDate ? moment(item.createdAt.toDate()) : moment(item.createdAt, ['DD MMM YYYY', 'YYYY-MM-DD']);
            rows.push({
                key: index + 1,
                name: item.fullName ?? '',
                phone: item.phoneNumberAuth ?? '',
                email: item.emailAuth ?? '',
                userStatus: <Tag severity={sev as any} value={status || '—'} />,
                createdAt: m.isValid() ? m.format('DD MMM YYYY') : '',
                action: <Button size="xs" rounded color="primary"
                                onClick={() => navigate(generatePath('/buyers/:id', {id: item.Uid ?? docSnap.id}))}
                                icon={<MDBIcon icon="eye"/>}/>
            });
        });
        setAllRows(rows);
        setDataArray(rows);
    }, [userSnapshot]);

    const search = (text: string) => {
        setSearchText(text);
        const q = text.toLowerCase();
        setDataArray(!q ? allRows : allRows.filter(r =>
            r.name.toLowerCase().includes(q) ||
            r.phone.toLowerCase().includes(q) ||
            r.email.toLowerCase().includes(q)
        ));
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Headerbar collapsed={collapsed} setCollapsed={setCollapsed}/>
            <Layout className="site-layout">
                <Sidebar collapsed={collapsed}/>
                <Content>
                    <Container className="mt-2">
                        <MDBRow>
                            <MDBCol>
                                <div className="page-header">
                                    <h4 className="page-title">
                                        Buyers
                                        <span className="page-title-count">({dataArray.length})</span>
                                    </h4>
                                    <Input
                                        placeholder="search by name, phone, email"
                                        value={searchText}
                                        onChange={(e: any) => search(e.target.value)}
                                        style={{minWidth: 260}}
                                        contentRight={<MDBIcon icon="search"/>}
                                    />
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <div style={{background:'#fff', borderRadius:12, border:'1px solid #eee',
                                             boxShadow:'0 1px 4px rgba(0,0,0,.06)', overflow:'hidden'}}>
                                    <Table columns={columns} dataSource={dataArray} loading={loading}
                                           rowKey="key" size="middle"
                                           pagination={{ defaultPageSize: 25, showSizeChanger: true,
                                                         pageSizeOptions:['25','50','100'],
                                                         showTotal: (t: number, r: number[]) => `${r[0]}–${r[1]} of ${t}` }}/>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </Container>
                </Content>
            </Layout>
        </Layout>
    );
}

export default Buyers;
